// WidgetOpcionesValidacionRapida.js
import React from "react";

const WidgetOpcionesValidacionRapida = (props) => {
  return (
    <div className="chat-options-container">
      <p className="react-chatbot-kit-chat-bot-message">
        Por favor, selecciona el método de validación:
      </p>
      <button
        onClick={() => {
          // Al seleccionar teléfono, se actualiza el método y se pide el dato
          props.actions.setValidacionMetodo("telefono");
          props.actions.sendBotResponse("Ingresa el teléfono:");
        }}
        className="chat-option-button"
      >
        Teléfono
      </button>
      <button
        onClick={() => {
          props.actions.setValidacionMetodo("email");
          props.actions.sendBotResponse("Ingresa el email:");
        }}
        className="chat-option-button"
      >
        Email
      </button>
      <button
        onClick={() => {
          props.actions.setValidacionMetodo("direccion");
          props.actions.sendBotResponse("Ingresa la dirección en el formato: Calle,Numero,Colonia,Ciudad");
        }}
        className="chat-option-button"
      >
        Dirección
      </button>

      <button
        onClick={() => {
          props.actions.setValidacionMetodo("nombre_cuenta");
          props.actions.sendBotResponse("Ingresa el nombre del cliente en el siguiente formato: Nombre(s), apellido paterno, apellido materno");
        }}
        className="chat-option-button"
      >
        Nombre del Cliente
      </button>
    </div>
  );
};

export default WidgetOpcionesValidacionRapida;
